export const emptyLocation = {
  name: '',
  city: '',
  state: '',
  postal_code: '',
  type: null,
  id: null,
}

export const emptyOrderLocation = {
  name: '',
  type: '',
  address: '',
  address_2: '',
  contact_name: '',
  contact_phone: '',
  contact_email: '',
  external_notes: '',
}

export const placeTypeIdByLocationType = {
  auction: 4,
  other: 5,
  body_shop: 8,
  business: 9,
  dealer: 10,
  residence: 11,
}

export const DEFAULT_PLACE_TYPE_ID = placeTypeIdByLocationType.other

export const locationTypeLabels = {
  auction: 'Auction',
  body_shop: 'Body Shop',
  business: 'Business',
  dealer: 'Dealer',
  residence: 'Residence',
  other: 'Other',
}

export const locationTypeOptions = [
  { label: 'Auction', value: 'auction' },
  { label: 'Body Shop', value: 'body_shop' },
  { label: 'Business', value: 'business' },
  { label: 'Dealer', value: 'dealer' },
  { label: 'Residence', value: 'residence' },
  { label: 'Other', value: 'other' },
]

export const placeTypeNameToLocationType = {
  'Auction': 'auction',
  'Body Shop': 'body_shop',
  'Business': 'business',
  'Dealer': 'dealer',
  'Dealer Lot': 'dealer',
  'Dealer Home': 'dealer',
  'Residence': 'residence',
  'Other': 'other',
}
